import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const Image = forwardRef(({ imageComponent: ImageComponent, ...props }, ref) => {
    const isGif = props.src?.includes('.gif');
    const loading = props.loading ?? (isGif ? 'lazy' : undefined);
    return !!ImageComponent ? (_jsx(ImageComponent, { ...props, loading, ref })) : (_jsx("img", { ...props, loading, ref }));
});
//# sourceMappingURL=Image.js.map